import * as Yup from 'yup';
import * as moment from 'moment';
import { FORMAT } from '../utils/dateOfBirthValidation';
export function getPostInitialValues() {
  let requestDeliveryDate = moment(new Date()).format(FORMAT)
  let currentTimeBegin = new Date()
  currentTimeBegin.setHours(8)
  currentTimeBegin.setMinutes(0)

  let beginHours = currentTimeBegin.getHours();
  let beginMinutes = currentTimeBegin.getMinutes()
  let beginCurrentTime = beginHours + ':' + beginMinutes

  let currentTimeEnd = new Date()
  currentTimeEnd.setHours(17)
  currentTimeEnd.setMinutes(0)

  let endHours = currentTimeEnd.getHours();
  let endMinutes = currentTimeEnd.getMinutes()
  let endCurrentTime = endHours + ':' + endMinutes

  return {
    cancelDate: requestDeliveryDate,
    requestedStartTime: beginCurrentTime,
    requestedEndTime: endCurrentTime,
    comment:""
  };
}

const VALIDATION_SCHEMA = () => {
  let schemaAttributes = {
  }
  return Yup.object().shape(schemaAttributes);
}
export { VALIDATION_SCHEMA };
